import ApiService from './api';
import api from '../hooks/useHttp';

class CustomerService extends ApiService {
  constructor() {
    super('/api/customers');
  }

  // Get all customers with pagination and filters
  async getCustomers(params = {}) {
    return await this.get('', params);
  }

  // Get customer by ID
  async getCustomerById(id) {
    return await this.get(`/${id}`);
  }

  // Search customers with advanced filters
  async searchCustomers(filters = {}) {
    return await this.get('/search', filters);
  }

  // Get customer loads
  async getCustomerLoads(id, params = {}) {
    return await this.get(`/${id}/loads`, params);
  }

  // Create new customer
  async createCustomer(customerData) {
    return await this.create(customerData);
  }

  // Update customer
  async updateCustomer(id, customerData) {
    return await this.update(id, customerData);
  }

  // Delete customer
  async deleteCustomer(id) {
    return await this.delete(id);
  }

  // Delete customer file (PDF document)
  async deleteCustomerFile(id) {
    return await api.delete(`${this.baseUrl}/${id}/file`);
  }

  // Get users from allowedUsers of THIS specific customer
  async getAllowedUsers(customerId) {
    return await this.get(`/${customerId}/allowedUsers`);
  }
}

export default new CustomerService();

